import { Icon } from '../../common'

type Item = {
  title: string
  subtitle: string
}

type HeaderSubTileProps = {
  ItemInfo: Item[]
}

const HeaderSubTile: React.FC<HeaderSubTileProps> = ({ ItemInfo }) => {
  return (
    <div className="bg-white flex overflow-x-auto justify-between items-start p-5 relative">
      <div className="flex gap-4 divide-x divide-formBorder">
        {ItemInfo.map((child, index) => (
          <div key={index} className="flex gap-1 min-w-[228px] py-2 ps-6">
            <div className="size-7 rounded-sm border border-formBorder bg-primaryThin text-color_varient1 flex items-center justify-center">
              <Icon name="flash-icon" className="size-5" />
            </div>
            <div className="shrink-0 flex flex-col">
              <span className="text-blackAlt text-base font-medium">
                {child.title}
              </span>
              <span className="text-blackAlt leading-7 text-xl font-bold">
                {child.subtitle}
              </span>
            </div>
          </div>
        ))}
      </div>
      <div className="flex gap-1 absolute right-5 bg-white border-sm">
        <button
          className="flex items-center justify-center cursor-pointer size-6"
          aria-label="Scroll left"
        >
          <Icon name="chevron-left" className="size-4 block" />
        </button>
        <button
          className="flex items-center justify-center cursor-pointer size-6"
          aria-label="Scroll right"
        >
          <Icon name="chevron-right" className="size-4 block" />
        </button>
        <button
          className="flex items-center justify-center cursor-pointer size-6"
          aria-label="More options"
        >
          <Icon name="three_dot_horizontal" className="size-4 block" />
        </button>
      </div>
    </div>
  )
}

export default HeaderSubTile
